export function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              TRAMETAL
            </h3>
            <p className="text-gray-400 leading-relaxed mb-4">
              Providing secure VPN solutions to protect your online privacy and freedom. Based in Popayán, Colombia.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">
              <a href="#quick-links" className="hover:text-teal-400 transition-colors">
                Quick Links
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">
              <a href="#contact-info" className="hover:text-teal-400 transition-colors">
                Contact Info
              </a>
            </h4>
            <ul className="space-y-3">
              <li className="flex gap-2 text-gray-400">
                <i className="ri-mail-line mt-1 flex-shrink-0"></i>
                <a href="mailto:information@trametalsas.com" className="hover:text-teal-400 transition-colors">
                  information@trametalsas.com
                </a>
              </li>
              <li className="flex gap-2 text-gray-400">
                <i className="ri-phone-line mt-1 flex-shrink-0"></i>
                <a href="tel:+16362162205" className="hover:text-teal-400 transition-colors">
                  +1 636-216-2205
                </a>
              </li>
              <li className="flex gap-2 text-gray-400">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <span>Popayán, Colombia</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">
              <a href="#legal" className="hover:text-teal-400 transition-colors">
                Legal
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#privacy" className="text-gray-400 hover:text-teal-400 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#terms" className="text-gray-400 hover:text-teal-400 transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#cookies" className="text-gray-400 hover:text-teal-400 transition-colors">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} TRAMETAL S.A.S. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}